/**
 * Company-specific API Configuration
 * 
 * This configuration file maps each company's frontend domain to its
 * corresponding backend worker API endpoint.
 */

// Map of company domains to their respective API backends
const companyApiMap = {
  // Qawaem (Saudi ERP) — Railway API
  'qawaem-app.pages.dev': 'https://qawaem-api-production.up.railway.app/api',
  'app.qawaemai.com': 'https://qawaem-api-production.up.railway.app/api',
};

// Map of company domains to their display names
const companyNameMap = {
  'qawaem-app.pages.dev': 'QAWAEM',
  'app.qawaemai.com': 'QAWAEM',
};

// Get the current company name based on hostname
export const getCompanyName = () => {
  const hostname = window.location.hostname;
  
  // Direct match
  if (companyNameMap[hostname]) {
    return companyNameMap[hostname];
  }
  
  // Check for partial matches (for preview URLs with hashes)
  for (const domain in companyNameMap) {
    if (hostname.includes(domain.replace('.pages.dev', '')) && hostname.endsWith('.pages.dev')) {
      return companyNameMap[domain];
    }
  }
  
  return 'QAWAEM';
};

// Get the API backend for the current hostname
export const getCompanyApiBackend = () => {
  const hostname = window.location.hostname;
  
  // Direct match
  if (companyApiMap[hostname]) {
    return companyApiMap[hostname];
  }
  
  // Check for partial matches (for preview URLs with hashes)
  for (const domain in companyApiMap) {
    if (hostname.includes(domain.replace('.pages.dev', '')) && hostname.endsWith('.pages.dev')) {
      console.log(`Mapping ${hostname} to backend for ${domain}: ${companyApiMap[domain]}`);
      return companyApiMap[domain];
    }
  }
  
  // If no match found, log error and return default
  console.warn(`No API backend found for hostname: ${hostname}`);
  return '';
};

export default {
  getCompanyName,
  getCompanyApiBackend
};
